import React, { useState, useEffect } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import Fade from "react-reveal/Fade";
import { Alert, Spinner } from "react-bootstrap";
import axios from "axios";
import CustomHelmet from "../components/CustomHelmet";

const url =
  "https://www.hubsquares.com/php_files/processForgotPass.php/";
const Login = (props) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [spin, setSpin] = useState(false);

  const handleSubmit = async (event) => {
    setSpin(true);
    event.preventDefault();
    let formData = new FormData();
    formData.append("email", email);
    await axios
      .post(url, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        if (data.success === 1) {
          setSpin(false);
          setErrorValue(data.msg);
          setError(true);
          setEmail("");
        } else if (data.success === 0) {
          setErrorValue(data.msg);
          setSpin(false);
          setError(true);
        }
      });
  };

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error]);
  return (
    <div>
      <CustomHelmet page="Reset Password" />
      <div className="wrapper login_banner position-relative">
        <div className="overlay">
          <Navbar />

          <div className="banner">
            <div className=" text-center mt-6 container">
              <div className="row">
                <div className="col-3"></div>
                <div className="col-md-6 col-sm-12">
                  <h1 className="mb-3">Reset Password</h1>
                  {error && (
                    <Fade bottom collapse when={error}>
                      <Alert
                        variant={
                          errorValue === "Password sent to your mailbox"
                            ? "success"
                            : "danger"
                        }
                      >
                        {errorValue}
                      </Alert>
                    </Fade>
                  )}
                  <p>Enter your Email</p>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                      <div className="input-group">
                        <i className="fa fa-envelope position-absolute icon-l "></i>
                      </div>
                      <input
                        type="email"
                        className="form-control pl-5 input-pad form-control-lg"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="d-flex justify-content-center login-sec">
                      <button
                        type="submit"
                        className="btn border-0 auth-btn py-2 px-5 btn-danger btn-lg rad-0 addbtn"
                      >
                        Reset
                        {spin && (
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer style={{ marginTop: "0" }} />
    </div>
  );
};
export default Login;
